export const MIN_NUMBER_OF_PRINTS = 8;
export const NO_PRINTS = 0;
export const STEP = 4;
export const PRINT_NUMBER_PROMO = 10;
export const FORBIDDEN_NUMBER_OF_PRINTS = 4;
